import { render, staticRenderFns } from "./DxLocationSelector.vue?vue&type=template&id=258f89ea&"
import script from "./DxLocationSelector.vue?vue&type=script&lang=js&"
export * from "./DxLocationSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports